import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Categoria } from '@mobile/models/cardapio/cardapio.model';

@Injectable({ providedIn: 'root' })
export class CategoriasFirebaseService {
  constructor(private afs: AngularFirestore) {}

  async getAll(): Promise<Categoria[]> {
    const snapshot = await this.afs.firestore.collection('Categorias').get();
    return snapshot.docs.map(d => d.data() as Categoria);
  }
}
